// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    SEARCH_PAGE_LOADING() {
      return {
        isLoading: true,
        searchPage: action.searchPage
      };
    },
    SEARCH_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.searchPage
      };
    },
    SEARCH_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.searchPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
